export default {"src":"/_next/static/media/news-circular.605220a7.svg","height":139,"width":139,"blurWidth":0,"blurHeight":0};